module.exports = __webpack_public_path__ + "assets/Globe.388a013f.svg";